import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import './pocDetails.css';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";

const PocDetailsNew = ({
  label = localization.POCName,
  // fmcName = localization.fmcName,
  pocDesignation = localization.POCDesignation,
  phoneNumber = localization.phoneNumber,
  emailId = localization.emilSendTo,
  secondaryContact = localization.secondaryContact,
  isSupply = false,
  isb2b = false,
  pocType,
  pocTypeData,
  handleValue,
  corDropDownData,
  appartmentDropDown,
  b2bDropDown,
  prefilledData = null,
  isDefalut,
  fromPostsales = false,
  projectType=null,
}) => {
  const pocInputs = {
    pocVal: { id: null, value: '' },
    mailCamp: { id: null, value: '' },
    pocName: '',
    pocDesVal: '',
    number: '',
    email: '',
  };
  const optionFiled = {
    secondContact: '',
  };

  const isContact = {
    primaryContact: 'primaryContact',
    secondaryContact: 'secondaryContact',
  };
  
  const [pocData, setPocData] = useState(pocInputs);
  const [optFileds, setOptFileds] = useState(optionFiled);
  const [contact_one, setContact_one] = useState(false);
  const [contact_two, setContact_two] = useState(false);
  const [pocSiteType, setPocType] = useState();
  const [poc, setPoc] = useState('');
  const [isDemand, setIsDemand] = useState(null);

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setPocData(pocInputs);
      setOptFileds(optionFiled);
      setPocType();
      setPoc('');
    }
  };
// console.log(prefilledData);
  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        tp_poc_details,
        tp_poc_site_id,
        poc_type,
        other_poc_sites,
      } = prefilledData?.lead_data;
      setPocData({
        ...pocData,
        pocVal: {
          id: tp_poc_site_id ? tp_poc_site_id : null,
          value: poc_type ? poc_type : '',
        },
        pocDesVal: tp_poc_details?.designation,
        email: tp_poc_details?.email,
        pocName: tp_poc_details?.name,
        // fmcName: tp_poc_details?.fmc_name,
        number: `${tp_poc_details?.phone}`,
        mailCamp: {id: (tp_poc_details?.mail_campaign == 'Yes') ? 1 : 2, value: tp_poc_details?.mail_campaign}
      });
      setOptFileds({
        ...optFileds,
        secondContact: `${tp_poc_details?.secondary_contact}`,
        // poc: `${other_poc_sites}`
      });
      setPoc(other_poc_sites);
    }
  }, [prefilledData]);

  useEffect(() => {
    if (corDropDownData) {
      const { poc_site_types } = corDropDownData;
      setPocType(poc_site_types);
    }
  }, [corDropDownData]);

  useEffect(() => {
    (async () => {
    if(projectType == 4) {
       const url = Config.categoryDetials.supplyPocDropDown;
       const { data } = await axios.get(url);
       const poc_site_types = data?.response?.data?.supply_poc_types;
       setPocType(poc_site_types);
    } else {
      if (appartmentDropDown) { 
        const { poc_site_types } = appartmentDropDown;
        setPocType(poc_site_types); 
      }
    }
  })(); 
  }, [appartmentDropDown]);

  useEffect(() => {
    if (b2bDropDown) {
      const { poc_site_types } = b2bDropDown;
      setPocType(poc_site_types);
    }
  }, [b2bDropDown]);

  const handlePocData = () => {
    if (isSupply === true) {
      const pocSupplyObj = {
        email: pocData.email,
      };
      const isNotEmpty = handleValidateObj(pocSupplyObj);
      if (isNotEmpty !== false && Regex.email.test(pocData.email)) {
        // console.log('ert');
        handleValue({
          ...pocSupplyObj,
          number: pocData.number,
          pocName: pocData.pocName,
          // fmcName: pocData.fmcName,
          pocDesVal: pocData.pocDesVal,
        });
      } else {
        // console.log('epppp');
        handleValue(null);
      }
    }
    if (isSupply === false) {
      let isEmpty = false;
      if (isb2b === false) {
        isEmpty = handleValidateObj(pocData);
      } else {
        isEmpty = handleValidateObj({
          pocName: pocData.pocName,
          pocDesVal: pocData.pocDesVal,
          number: pocData.number,
          email: pocData.email,
        });
      }
      if (
        isEmpty !== false &&
        Regex.email.test(pocData.email) &&
        Regex.text.test(pocData.pocName) &&
        Regex.text.test(pocData.pocDesVal) &&
        pocData.number.match(Regex.phoneNumber)
      ) {
        handleValue({
          ...pocData,
          pocVal: pocData.pocVal.id,
          secondContact: optFileds.secondContact,
          poc: poc,
        });
      } else {
        handleValue(null);
      }
    }
  };

  const handleIsSame = (isContact_no, val = '') => {
    if (isContact_no === isContact.primaryContact && val !== '') {
      if (val === optFileds.secondContact) {
        setContact_two(false);
        setContact_one(true);
        setTimeout(() => {
          setPocData({ ...pocData, number: '' });
        }, 1000);
        return;
      }
    }
    if (isContact_no === isContact.secondaryContact && val !== '') {
      if (val === pocData.number) {
        setContact_two(true);
        setContact_one(false);
        setTimeout(() => {
          setOptFileds({ ...optFileds, secondContact: '' });
        }, 1000);
        return;
      }
    }
  };

  useEffect(() => {
    handlePocData();
  }, [pocData, optFileds]);
// console.log(pocData);

const handleDemand = ({ id, value }) => {
  setIsDemand(id);
  setPocData({
    ...pocData,
    pocVal: { id: id, value: value },
  });
}
// const handleSupplyName = () => {
//   if (isDemand === 1) {
//     return (
//       <ConstantInput
//         label={fmcName}
//         regex={Regex.text.test(pocData.fmcName)}
//         errorMsg={
//           pocData.fmcName
//             ? localization.requiredCharacter
//             : localization.requiredPocName
//         }
//         type="text"
//         handleChange={(val) => setPocData({ ...pocData, fmcName: val })}
//         required={false}
//         // isStarRequired={isSupply ? false : true}
//         value={pocData.fmcName}
//       />
//     );
//   }
// };

  return (
    // <FormSection title={localization.pocTitle}>
    <div className='card'>
        <div className='card-header n-card'>{localization.pocTitle}</div>
        <div className='card-body'>
      <div className="form-ctrl-col">
      {(isSupply || isb2b) || (fromPostsales === true) ? null : (
        <Fragment>
          <DropDownInput
            label={localization.pocType}
            data={pocSiteType}
            required
            isStarRequired={true}
            errorMsg={localization.requiredPocType}
            getIdValue={(val) => handleDemand(val)}
            value={pocData.pocVal.value.length > 0 ? pocData.pocVal.value : ''}
          />
          {pocData.pocVal?.id === 9 && (
            <ConstantInput
              label={localization.poc}
              handleChange={(val) => setPoc(val)}
              value={poc}
              regex={Regex.text.test(poc)}
              required
              isStarRequired={true}
              errorMsg={localization.isRequired}
            />
          )}
        </Fragment>
      )}

      <ConstantInput
        label={label}
        regex={Regex.text.test(pocData.pocName)}
        errorMsg={
          pocData.pocName
            ? localization.requiredCharacter
            : localization.requiredPocName
        }
        type="text"
        handleChange={(val) => setPocData({ ...pocData, pocName: val })}
        required={isSupply ? false : true}
        isStarRequired={true}
        value={pocData.pocName}
      />
      {/* {handleSupplyName()} */}
      {/* {fromPostsales ? null : (
      <ConstantInput
        label={fmcName}
        regex={Regex.text.test(pocData.fmcName)}
        errorMsg={
          pocData.fmcName
            ? localization.requiredCharacter
            : localization.requiredPocName
        }
        type="text"
        handleChange={(val) => setPocData({ ...pocData, fmcName: val })}
        required={false}
        // isStarRequired={isSupply ? false : true}
        value={pocData.fmcName}
      />
      )} */}

      <ConstantInput
        label={pocDesignation}
        regex={Regex.text.test(pocData.pocDesVal)}
        errorMsg={
          pocData.pocDesVal
            ? localization.requiredCharacter
            : localization.requiredPocDesig
        }
        type="text"
        handleChange={(val) => setPocData({ ...pocData, pocDesVal: val })}
        required={isSupply ? false : true}
        isStarRequired={true}
        value={pocData.pocDesVal}
      />

      <ConstantInput
        label={phoneNumber}
        regex={Regex.phoneNumber.test(pocData.number)}
        errorMsg={
          isSupply
            ? localization.requiredPhonenumber
            : contact_one
            ? localization.numberShouldBeDifferent
            : localization.numericError
        }
        maxLength={10}
        minLength={10}
        tenDigitsValidation={true}
        className="countrycode"
        isPrefix
        prefixText={'+91'}
        type="number"
        handleChange={(val) => {
          handleIsSame(isContact.primaryContact, val);
          setPocData({ ...pocData, number: val });
        }}
        required={isSupply ? false : true}
        isStarRequired={true}
        value={pocData?.number !== 'undefined' ? pocData?.number : ''}
        blockError={contact_one}
      />

      <ConstantInput
        label={emailId}
        regex={Regex.email.test(pocData.email)}
        errorMsg={
          pocData.email === ''
            ? localization.emailAddressRequired
            : localization.emailError
        }
        type="email"
        handleChange={(val) => setPocData({ ...pocData, email: val })}
        required
        isStarRequired={true}
        value={pocData.email}
      />
      {(isSupply) || (fromPostsales === true) ? null : (
        <ConstantInput
          label={secondaryContact}
          errorMsg={
            contact_two
              ? localization.numberShouldBeDifferent
              : optFileds.secondContact !== ''
              ? localization.numericError
              : localization.isRequired
          }
          className="countrycode"
          isPrefix
          prefixText={'+91'}
          type="number"
          maxLength={10}
          minLength={10}
          handleChange={(val) => {
            handleIsSame(isContact.secondaryContact, val);
            setOptFileds({ secondContact: val });
          }}
          value={
            optFileds?.secondContact !== 'undefined'
              ? optFileds?.secondContact
              : ''
          }
          blockError={contact_two}
        />
      )}
      {(isSupply || projectType===4) ? null :
        <DropDownInput
          data={[
            { name: 'Yes', id: 1 },
            { name: 'No', id: 2 },
          ]}
          label={localization.mailCamp}
          required
          // isStarRequired={true}
          // errorMsg={localization.requiredgstDetails}
          getIdValue={(val) => setPocData({
            ...pocData,
            mailCamp: { id: val.id, value: val.value },
          })}
          value={(pocData.mailCamp.value && pocData.mailCamp.value.length > 0) ? pocData.mailCamp.value : ''}
        />
      }
       </div>
       </div>
     </div>
  );
};

export default PocDetailsNew;
